import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { env } from 'process';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class RoomService {

  public baseUrl: string;
  public id_room: string;

  constructor(private _http: Http) {
    this.baseUrl = environment.apiUrl;
    
  }

  
  getIds(data:any){ 
    let json = JSON.stringify(data);
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + data.auth_token);
    return this._http.post(this.baseUrl + 'getData', json, {headers: headers}).map(res => res.json());
  }

  exportAsExcelFile(json: any[], excelFileName: string): void {
    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  
  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


  createRoom(roomData: any): Observable<any> {
    const headers = new Headers({
      'Authorization': environment.VIDEOSDK_API_TOKEN,
      'Content-Type': 'application/json'
    });

    return this._http.post("https://api.videosdk.live/v2/rooms" , roomData, { headers }).map(res => res.json());
  }

  deactivateRoom(room_Id: any): Observable<any> {
    
    const headers = new Headers({
      'Authorization': environment.VIDEOSDK_API_TOKEN,
      'Content-Type': 'application/json'
    });

    return this._http.post("https://api.videosdk.live/v2/rooms/deactivate" , room_Id, { headers }).map(res => res.json());
  }

  getSession(room_Id: any): Observable<any> {
    
    const headers = new Headers({
      'Authorization': environment.VIDEOSDK_API_TOKEN,
      'Content-Type': 'application/json'
    });

    return this._http.get(`https://api.videosdk.live/v2/sessions?roomId=${room_Id}` ,{ headers }).map(res => res.json());
  }

  getRecordingMeeting(room_Id: any): Observable<any> {
    
    const headers = new Headers({
      'Authorization': environment.VIDEOSDK_API_TOKEN,
      'Content-Type': 'application/json'
    });

    return this._http.get(`https://api.videosdk.live/v2/recordings?roomId=${room_Id}`, { headers }).map(res => res.json());
  }
}




// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/chat/room/room.service.ts